import { render, staticRenderFns } from "./StaffReceipt.vue?vue&type=template&id=366d6c69"
import script from "./StaffReceipt.vue?vue&type=script&lang=js"
export * from "./StaffReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports